export function processRequirement(requirement, serverCount) {
    return serverCount ? Math.round(requirement / serverCount * 10) / 10 : requirement
}